import React from "react";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import NewHireKitItem from "../admin/NewHireKitItem";

const ConfirmKitModal = ({ show, close, confirm, items, address, polybagChecked, polybagLabel }) => {

    return (
        <Modal dialogClassName="modal-70w" show={show} onHide={close}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Kit<br /></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <h4>Delivering to {address.name}</h4>
                    <p style={{ marginLeft: 30, padding: 5, border: "1px solid #CCCCCC" }}>{address.street}<br />
                        {address.street2 != null && address.street2 != "" && <>{address.street2}<br /></>}
                        {address.city}, {address.state} {address.zip}<br />
                        {polybagChecked && <>Polybag Packaging with Label: <strong>{polybagLabel}</strong><br /></>
                        }
                    </p>
                    <ul>
                        {items.map(item => (
                            <NewHireKitItem item={item.item} inventory={null} setSize={null} remove={null} edit={false} currentSize={item.selectedSize} />
                        ))}
                    </ul>
                </div>
                <Button onClick={close} variant="secondary" style={{ marginTop: 20, marginRight: 20 }}>
                    Edit Order
                </Button>
                <Button onClick={confirm} variant="success" style={{ marginTop: 20 }}>
                    Confirm Order
                </Button>

            </Modal.Body>
        </Modal >
    );
};

export default ConfirmKitModal; 